// Ленивая загрузка Swiper: динамический import → async-чанк (webpack cacheGroup
// `ui-vendors`). ~27 КиБ уходят из критического окна загрузки: на страницах без
// активных слайдеров (интро в один слайд) чанк не качается вовсе, галереи карточек
// тянут его по приближению к вьюпорту (range.js, IntersectionObserver).
// Возвращает Promise<Swiper | null> (null — если чанк не загрузился).
let loader = null;

export function loadSwiper() {
  if (!loader) {
    loader = Promise.all([
      import('swiper'),
      import('swiper/modules'),
      import('swiper/css'),
      import('swiper/css/navigation'),
      import('swiper/css/pagination'),
      import('swiper/css/scrollbar'),
      import('swiper/css/effect-fade'),
    ])
      .then(([swiperMod, modulesMod]) => {
        const Swiper = swiperMod.default;
        const { Navigation, Pagination, Scrollbar, EffectFade, Autoplay } = modulesMod;
        Swiper.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);
        // Совместимость: модули по месту используют window.Swiper
        if (typeof window.Swiper === 'undefined') window.Swiper = Swiper;
        if (typeof window.SwiperModules === 'undefined') {
          window.SwiperModules = { Navigation, Pagination, Scrollbar, EffectFade, Autoplay };
        }
        return Swiper;
      })
      .catch((err) => {
        loader = null; // разрешить повторную попытку
        console.warn('Swiper: не удалось загрузить чанк', err);
        return null;
      });
  }
  return loader;
}
